import { render, staticRenderFns } from "./ProfileFieldsList.vue?vue&type=template&id=0c0995da&scoped=true&"
import script from "./ProfileFieldsList.vue?vue&type=script&lang=ts&"
export * from "./ProfileFieldsList.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileFieldsList.vue?vue&type=style&index=0&id=0c0995da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0995da",
  null
  
)

export default component.exports